import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiFolder } from "react-icons/fi";
import { MdOutlineFolderSpecial, MdWindow } from "react-icons/md";
import { useNavigate, useSearchParams } from "react-router-dom";

function Header({ step, setStep, campaignData, adsetsData }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const addBoxBorder = useColorModeValue("gray.800", "gray.50");
  const borderColor = useColorModeValue("gray.200", "purple.800");

  const isAdLinkDisabled =
    adsetsData?.data?.length === 0 || campaignData?.adsets?.length === 0;

  // helper to update ?step
  const updateStepInUrl = (newStep) => {
    const params = new URLSearchParams(searchParams);
    params.set("step", String(newStep));
    // preserve campaign id in path — we stay on same path, only update query
    setSearchParams(params, { replace: true });
    setStep(newStep);
  };

  return (
    <Box width="100%">
      <Box
        borderBottom="1px solid"
        borderColor={borderColor}
        p={"10px"}
        px={"20px"}
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center" flex={1}>
            <Breadcrumb spacing="8px" separator={<ChevronRightIcon />}>
              <BreadcrumbItem>
                <BreadcrumbLink
                  color={step === 0 ? "brand.500" : addBoxBorder}
                  onClick={() => {
                    updateStepInUrl(0);
                  }}
                  _hover={{ textDecoration: "none" }}
                  _focus={{ boxShadow: "none" }}
                >
                  <Flex align="center">
                    <Icon as={FiFolder} mr={2} />
                    Campaign
                  </Flex>
                </BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem>
                <BreadcrumbLink
                  color={step === 1 ? "brand.500" : addBoxBorder}
                  onClick={() => {
                    // also navigate to campaign path (keeps same path; query updated below)
                    if (campaignData?._id) {
                      navigate(`/launchpad/${campaignData._id}`);
                    }
                    updateStepInUrl(1);
                  }}
                  _hover={{ textDecoration: "none" }}
                  _focus={{ boxShadow: "none" }}
                >
                  <Flex align="center">
                    <Icon as={MdWindow} mr={2} />
                    Ad Set
                  </Flex>
                </BreadcrumbLink>
              </BreadcrumbItem>

              <BreadcrumbItem>
                <BreadcrumbLink
                  onClick={() => {
                    if (!isAdLinkDisabled) {
                      const params = new URLSearchParams(searchParams);
                      params.set("step", "2");
                      setSearchParams(params, { replace: true });
                      setStep(2);
                      if (campaignData?._id) {
                        navigate(`/launchpad/${campaignData._id}?step=2`, { replace: true });
                      }
                    }
                  }}
                  _hover={{ textDecoration: "none" }}
                  _focus={{ boxShadow: "none" }}
                  color={
                    isAdLinkDisabled
                      ? "gray.500"
                      : step === 2
                      ? "brand.500"
                      : addBoxBorder
                  }
                  cursor={isAdLinkDisabled ? "not-allowed" : "pointer"}
                >
                  <Flex align="center">
                    <Icon as={MdOutlineFolderSpecial} mr={2} />
                    Ad
                  </Flex>
                </BreadcrumbLink>
              </BreadcrumbItem>

            </Breadcrumb>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
}

export default Header;
